"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _PanelHeader = _interopRequireDefault(require("./PanelHeader"));

var _PanelBody = _interopRequireDefault(require("./PanelBody"));

var _classnames = _interopRequireDefault(require("classnames"));

var StatelessPanel = function StatelessPanel(_ref) {
  var children = _ref.children,
      customClass = _ref.customClass,
      _ref$collapsible = _ref.collapsible,
      collapsible = _ref$collapsible === void 0 ? false : _ref$collapsible,
      title = _ref.title,
      titleClass = _ref.titleClass,
      bodyClass = _ref.bodyClass,
      customTogglePanel = _ref.customTogglePanel,
      _ref$newStyle = _ref.newStyle,
      newStyle = _ref$newStyle === void 0 ? false : _ref$newStyle,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      heading = _ref.heading,
      isActivePanel = _ref.isActivePanel,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error;
  var hasChildren = Array(children).toString() !== '';
  var baseClass = 'panel';
  if (newStyle) baseClass = "".concat(baseClass, "-new");
  return (0, _preact.h)("div", null, heading && (0, _preact.h)("h2", {
    className: "panel-new__heading"
  }, heading), (0, _preact.h)("div", {
    className: (0, _classnames.default)(customClass, (0, _defineProperty2.default)({}, "".concat(baseClass, "-collapsed"), !isOpen || !hasChildren))
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)(baseClass, {
      'panel-active': isActivePanel,
      'panel-error': error
    })
  }, title ? (0, _preact.h)(_PanelHeader.default, {
    newStyle: newStyle,
    collapsible: collapsible,
    isOpen: isOpen,
    togglePanel: function togglePanel() {
      return customTogglePanel === null || customTogglePanel === void 0 ? void 0 : customTogglePanel();
    },
    title: title,
    customClass: titleClass
  }) : null, hasChildren ? (0, _preact.h)(_PanelBody.default, {
    collapsible: collapsible,
    isOpen: isOpen,
    customClass: (0, _classnames.default)(bodyClass, {
      'panel-body--static': newStyle && !collapsible
    }),
    disabled: disabled
  }, children) : null)));
};

var _default = StatelessPanel;
exports.default = _default;